// removed by extract-text-webpack-plugin
module.exports = {"Home":"src-App-pages-Home-index__Home--ymCyK","Home-floatingWrapper":"src-App-pages-Home-index__Home-floatingWrapper--2vwIN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/index.scss
// module id = 822
// module chunks = 0